import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  explanationText: {
    color: theme.palette.primary.default
  },
  closeButton: {
    color: [theme.palette.primary.default, "!important"]
  },
  removeButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "red"
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/DeleteOrg/styles.js